var React = require('react');

function Arrows (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","fillRule":"evenodd","d":"M21.509 16.523l4.082 4.082c.329.329.466.696.466 1.048.01.364-.126.745-.466 1.085l-4.082 4.082c-1.414 1.414-3.536-.707-2.121-2.121l1.48-1.481H6.51c-2 0-2-3 0-3h14.452l-1.574-1.574c-1.415-1.414.707-3.535 2.121-2.12zm-9.84-8.935l-1.48 1.48h14.359c2 0 2 3 0 3H10.096l1.574 1.574c1.414 1.414-.708 3.536-2.122 2.122l-4.082-4.082c-.329-.33-.466-.696-.466-1.049-.01-.363.126-.744.466-1.085l4.082-4.082c1.414-1.414 3.536.707 2.122 2.122z"}));
}

Arrows.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = Arrows;

Arrows.default = Arrows;
